export default "__VITE_ASSET__DUCgNobG__"